export const USERS_VIEW = "users";

export const DOCTORS_VIEW = "doctors";
